// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"0bf98aba","107":"72348a2f","497":"2cbc5093","515":"360060e2","537":"699d9200","595":"45b6d040","617":"fd9b80e5","643":"a8be6021","664":"a8a45791","854":"0837258a","972":"93f10784"}[chunkId] + ".chunk.css";
};